import { createFeatureFlags } from '@economic/react-app';

export const { useFeatureFlags, flags } = createFeatureFlags({
    flags: ['helpDrawer'],
});

export type FeatureFlagName = (typeof flags)[number];
